import { Navigate, Route } from "react-router";
import { Routes } from "react-router-dom";
import { PreserveSearchNavigate } from "../../components/Navigate/PreserveSearchNavigate.tsx";
import { Query } from "../../components/Query/Query.tsx";
import { Spinner } from "../../components/Spinner/Spinner.tsx";
import { BOARDS, HOME, WORKSPACE_MODELS, WORKSPACES } from "../../routes.ts";
import { BoardView } from "../Board/Board.tsx";
import { UpgradeDialog } from "../components/UpgradeDialog/UpgradeDialog.tsx";
import { HomeView } from "../Home/HomeView.tsx";
import { useUser } from "../hooks/useUser.ts";
import { useWorkspaceUuid } from "../hooks/useWorkspaceUuid.ts";
import { ModelCreationView } from "../Model/ModelCreationView.tsx";
import {
  useLastSelectedWorkspaceUuid,
  useLastSelectedWorkspaceUuidStore,
} from "./hooks/useLastSelectedWorkspaceUuid.ts";

export const WorkspaceRedirect = () => {
  const { user } = useUser();
  const lastSelectedWorkspaceUuid = useLastSelectedWorkspaceUuid();
  if (!user) return <Spinner />;

  return (
    <Navigate
      replace
      to={`${WORKSPACES}/${
        lastSelectedWorkspaceUuid ?? user.workspaces[0].uuid
      }`}
    />
  );
};

export const WorkspaceView = () => {
  const workspaceUuid = useWorkspaceUuid();
  const { user } = useUser();

  return (
    <Query
      queryKey={`workspaces/${workspaceUuid}`}
      onSuccess={() => {
        if (user?.uuid) {
          useLastSelectedWorkspaceUuidStore.updateLastSelectedWorkspaceUuid({
            userUuid: user.uuid,
            workspaceUuid,
          });
        }
      }}
      onError={() => {
        if (user?.uuid) {
          useLastSelectedWorkspaceUuidStore.resetLastSelectedWorkspaceUuid({
            userUuid: user.uuid,
          });
        }
      }}
    >
      {() => (
        <>
          <Routes>
            <Route path={`${HOME}/*`} element={<HomeView />} />
            <Route path={`${BOARDS}/:boardUuid/*`} element={<BoardView />} />
            <Route
              path={`${WORKSPACE_MODELS}/:modelUuid/*`}
              element={<ModelCreationView />}
            />
            <Route
              path="*"
              element={<PreserveSearchNavigate replace to={HOME} />}
            />
          </Routes>
          <UpgradeDialog />
        </>
      )}
    </Query>
  );
};
